var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SettingsBanner'),(_vm.loaded)?_c('b-container',{staticClass:"mb-5"},[_c('SettingsTitle',{attrs:{"title":'Privacy Settings'}}),_c('b-row',[_c('SectionHeading',{attrs:{"name":'Privacy Settings'}})],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }